module.exports = __webpack_public_path__ + "static/media/image.b48eb9e3.jpg";